<div class="animated-placeholder"
  [ngStyle]="{
    'height': height,
    'width': width,
    'margin-top': marginTop,
    'margin-bottom': marginBottom,
    'margin-left': marginLeft,
    'margin-right': marginRight,
    'border-radius': radius,
    'display': display
  }">
</div>